import { Link, useLocalSearchParams } from 'expo-router';
import { ScrollView } from 'react-native';
import { useQuery, useSubscription } from 'urql';
import FadeInContent from '@/components/Animation/FadeInContent';
import Avatar from '@/components/Custom/Avatar';
import Item from '@/components/UI/PressableRow';
import Text from '@/components/UI/Text';
import { graphql } from '@/gql/graphql';
import useUserId from '@/hooks/useUserId';
import { EVENT_TEAM_LIMIT } from '@/utils/constants';

const GetEventDetailTeams = graphql(/* GraphQL */ `
  query GetEventDetailTeams($eventId: uuid!, $teamLimit: Int!) {
    event_by_pk(id: $eventId) {
      id
      event_teams(
        limit: $teamLimit
        order_by: [{ is_home: asc }, { team: { title: asc } }]
      ) {
        event_id
        team_id
        team {
          id
          avatar_id
          home_primary_color
          title
          total: team_people_aggregate {
            aggregate {
              count
            }
          }
        }
      }
    }
  }
`);
const WatchEventDetailTeams = graphql(/* GraphQL */ `
  subscription WatchEventDetailTeams($eventId: uuid!, $teamLimit: Int!) {
    event_by_pk(id: $eventId) {
      id
      event_teams(
        limit: $teamLimit
        order_by: [{ is_home: asc }, { team: { title: asc } }]
      ) {
        event_id
        team_id
        team {
          id
          avatar_id
          home_primary_color
          title
          total: team_people_aggregate {
            aggregate {
              count
            }
          }
        }
      }
    }
  }
`);
type EventDetailTeamsProps = {
  basePath: string;
};
function EventDetailTeams({ basePath }: EventDetailTeamsProps) {
  const personId = useUserId();
  const { eventId } = useLocalSearchParams<{
    eventId?: string;
  }>();
  const [{ data, fetching }] = useQuery({
    query: GetEventDetailTeams,
    variables: {
      eventId: eventId || '',
      teamLimit: EVENT_TEAM_LIMIT,
      personId,
    },
    pause: !eventId,
  });
  useSubscription({
    query: WatchEventDetailTeams,
    variables: {
      eventId: eventId || '',
      teamLimit: EVENT_TEAM_LIMIT,
      personId,
    },
    pause: !eventId,
  });
  return (
    <FadeInContent fetching={fetching}>
      <ScrollView>
        {data?.event_by_pk?.event_teams?.map((eventTeam) => (
          <Link
            key={eventTeam.team.id}
            href={{
              pathname: `${basePath}/team/[teamId]`,
              params: {
                teamId: eventTeam.team.id,
              },
            }}
            asChild
          >
            <Item>
              <Avatar
                size="md"
                id={eventTeam.team.avatar_id!}
                color={eventTeam.team.home_primary_color}
                name={eventTeam.team.title}
              />
              <Text flexShrink={1} numberOfLines={1} size="lg">
                {eventTeam.team.title}
              </Text>
            </Item>
          </Link>
        ))}
      </ScrollView>
    </FadeInContent>
  );
}
export default EventDetailTeams;
